module.exports = __webpack_public_path__ + "7d3d87054741bbf626a989ffba02093b.png";